var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#4535AF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C24.8174 16 21.7652 17.2643 19.5147 19.5147C17.2643 21.7652 16 24.8174 16 28C16 31.1826 17.2643 34.2348 19.5147 36.4853C21.7652 38.7357 24.8174 40 28 40L28 28V16Z",
    fill: "#4535AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40C31.1826 40 34.2348 38.7357 36.4853 36.4853C38.7357 34.2348 40 31.1826 40 28C40 24.8174 38.7357 21.7652 36.4853 19.5147C34.2348 17.2643 31.1826 16 28 16L28 28L28 40Z",
    fill: "#CFCAEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicon2);
export default __webpack_public_path__ + "static/media/picon2.9a77ac8e0e204482f80be4dacd2ddd3e.svg";
export { ForwardRef as ReactComponent };